import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"

export enum ReadyToSplitStatus {
    ready = "ready",
    notActive = "notActive",
    borrowedAsset = "borrowedAsset",
    referenceValueMissed = "referenceValueMissed",
    splitOperationInProgress ="splitOperationInProgress"
}

export interface IGetAssetReadyToSplitDto {
    status?: ReadyToSplitStatus
    bookingPeriod?:string
    links?: IApiLink[]
}

export default class AssetReadyToSplit {
    status?: ReadyToSplitStatus
    bookingPeriod?:string
    linkSplitAsset?: IApiLink

    constructor({
        status,
        bookingPeriod,
        links
    }: IGetAssetReadyToSplitDto) {
        this.status = status
        this.bookingPeriod=bookingPeriod
        this.linkSplitAsset = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.splitAsset
            && lnk.rel === ApiLinkRel.new
        )
    }
}
